import * as React from 'react';
import { useHistory } from 'react-router';

import arrowLeft from '../../../../assets/images/arrow-left.svg';
import arrowRight from '../../../../assets/images/arrow-right.svg';
import { Button } from '../../../../components/Button';
import { ROUTES } from '../../../../router/consts';
import { ICareerVacancy } from '../../store/models';
import { VacancyItemList } from './vacanyItemList';

interface IProps {
    vacancy: ICareerVacancy;
}

export const VacancyItem: React.FC<IProps> = ({
    vacancy: {
        deadline,
        description,
        position,
        requirements,
        suggestions,
        id,
    }
}) => {
    const [isDetailed, toggleDetailed] = React.useState<boolean>(false);
    const { push } = useHistory();

    return (
        <div className="vacancy">
            <div className="vacancy__header" onClick={() => toggleDetailed(!isDetailed)}>
                <div className="vacancy__header__position">
                    <h1>{position}</h1>
                </div>
                <div className="vacancy__header__arrow">
                    <img src={isDetailed ? arrowLeft : arrowRight} alt="" />
                </div>
            </div>

            {isDetailed && (
                <div className="vacancy__body">
                    <div className="vacancy__body__description">
                        <p>{description}</p>
                    </div>
                    {
                        Boolean(requirements.length) && (
                            <div className="vacancy__body__requirements">
                                <div className="vacancy__body__requirements-title">
                                    <h3>What You'll Do</h3>
                                </div>
                                {requirements.map(({ id: requirementId, text }) => (
                                    <VacancyItemList key={requirementId} text={text} />
                                ))}
                            </div>
                        )
                    }
                    {
                        Boolean(suggestions.length) && (
                            <div className="vacancy__body__suggestions">
                                <div className="vacancy__body__suggestions-title">
                                    <h3>What You'll Bring</h3>
                                </div>
                                {suggestions.map(({ id: suggestionId, text }) => (
                                    <VacancyItemList key={suggestionId} text={text} />
                                ))}
                            </div>
                        )
                    }
                    <div className="vacancy__body__deadline">
                        <div className="vacancy__body__deadline__title">
                            <h3>
                                Apply by {deadline} Job will be taken down when vacancy is filled.
                            </h3>
                        </div>
                        <div>
                            <Button
                                onClick={() => {
                                    push(ROUTES.CAREERS_APPLY + `?position=${id}`);
                                }}
                                className="vacancy__body__deadline__button"
                            >
                                Apply now
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
